import PropTypes from 'prop-types';

import proNotifications from 'modules/proNotifications';

import AvatarIcon from 'components/AvatarIcon';
import StateLink from 'components/StateLink';

import './Notification.scss';

/**
 * Client reschedule notification
 */
export default function ClientReschedule(props) {
  const { notification } = props;
  const localStart = moment(notification.local_start);

  return (
    <StateLink
      to="provider.appointment"
      params={{ viewApptId: notification.object_id }}
      clickTracking={{
        name: proNotifications.NOTIFICATION_CLICKED_EVENT,
        params: proNotifications.createNotificationParams(notification),
      }}
    >
      <section className="client-booking notification">
        <div className="icon">
          <AvatarIcon
            icon={notification.client_thumbnail}
            name={notification.client_name}
          />
        </div>
        <section className="notification-body">
          <p className="notification-text">
            <strong>
              {notification.client_name} rescheduled&nbsp;
            </strong>
            <span>
              {notification.service_name}
              &nbsp;for {localStart.format('dddd, MMM D')}
              &nbsp;at {localStart.format('h:mm A')}
            </span>
          </p>
          <p className="from-now">
            {proNotifications.getFromNowDisplay(notification.creation_time)}
          </p>
        </section>
      </section>
    </StateLink>
  );
}

ClientReschedule.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
